import React from 'react';
import { useState, useEffect, Fragment } from "react";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { configData } from "../../../../config/systemconfigurationconstants";
import UseLambdaInvocations from '../../../../hooks/useLambdaInvocations';
import * as AWS from 'aws-sdk';
import lambdaConfig from '../../../../hooks/lambdaConfig';
import { ToastContainer, toast } from "react-toastify";
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import InputGroup from 'react-bootstrap/InputGroup';
import { useEncryption } from '../../../../customHooks/useEncryption';
const UserCreation = ({ show, handleClose, usecaseList, userRole, userProvider, getUserDetails, mode, userData, userList, getUserListForUpdate, setSearchTerm }) => {
    const { encrypt, decrypt } = useEncryption();
    const getCookie = (name) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) {
            return decodeURIComponent(parts.pop().split(';').shift());
        }
        return null;
    };
    const { invokeLambda, loading, error } = UseLambdaInvocations();
    const [clientList, setClientList] = useState([]);
    const [showPassword, setShowPassword] = useState(false);

    const lambda = new AWS.Lambda({
        region: configData.LAMBDA_REGION,
        accessKeyId: decrypt(getCookie('ak')),
        secretAccessKey: decrypt(getCookie('sk'))
    });
    const initialFormData = {
        userName: '',
        firstName: '',
        lastName: '',
        middleName: '',
        email: '',
        ClientID: '',
        useCase: '',
        additionalUseCase: '',
        password: '',
        userRole: '',
        provider: '',
        isTwoFactorEnabled: false,
    };
    const [formData, setFormData] = useState(initialFormData);
    const mapUserToFormData = (user) => ({
        userName: user.UserName || '',
        firstName: user.FirstName || '',
        lastName: user.LastName || '',
        middleName: user.MiddleName || '',
        email: user.EmailID || '',
        ClientID: user.ClientID || '',
        useCase: user.UseCaseId || '',
        additionalUseCase: '',
        password: '',
        userRole: user.RoleMasterId || '',
        provider: user.Provider || '',
        isTwoFactorEnabled: user.IsTwoFactorEnabled || false,
        enableProvider: !!user.Provider, // enable dropdown if provider exists
    });
    useEffect(() => {
        if (mode === 'edit' && userData && show) {
            setFormData(mapUserToFormData(userData));
            if (userData?.UseCaseId) {
                handleUsecaseChange(userData?.UseCaseId);
            }
        }
    }, [mode, userData, show]);

    const togglePasswordVisibility = () => {
        setShowPassword((prev) => !prev);
    };
    const [formErrors, setFormErrors] = useState({
        email: '',
        password: '',
    });
    const [touched, setTouched] = useState({
        userName: false,
        firstName: false,
        lastName: false,
        email: false,
        password: false,
        useCase: false,
        ClientID: false,
        userRole: false,
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value,
        });
        if (name === 'useCase') {
            handleUsecaseChange(value); // Call your custom method here
        }
    };
    const handleUsecaseChange = (value) => {
        let selectedUsecase = usecaseList.find(x => x.UseCaseID == value);
        let getClientListUnderSelectedUseCase = selectedUsecase ? selectedUsecase.Client : [];
        setClientList(getClientListUnderSelectedUseCase)
    }
    const handleBlur = (e) => {
        const { name } = e.target;
        setTouched((prev) => ({
            ...prev,
            [name]: true,
        }));
    };


    // Email validation
    const validateEmail = (email) => {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailRegex.test(email);
    };

    // Password validation
    const getPasswordError = (password) => {
        if (!password) {
            return "Password is required.";
        }
        if (password.length < 8) {
            return "Password must be at least 8 characters.";
        }
        if (!/[A-Za-z]/.test(password)) {
            return "Password must contain at least one letter.";
        }
        if (!/\d/.test(password)) {
            return "Password must contain at least one number.";
        }
        if (!/[@$!%*#?&]/.test(password)) {
            return "Password must contain at least one special character.";
        }
        return ""; // ✅ No error
    };

    const getUserNameError = (userName) => {
        if (!userName.trim()) {
            return "Username is required.";
        }
        if (/\s/.test(userName)) {
            return "Username must not contain spaces.";
        }
        return "";
    };

    // Check form validity
    useEffect(() => {
        const errors = {};

        // Required Fields
        if (!formData.userName.trim()) {
            errors.userName = "Username is required.";
        } else if (/\s/.test(formData.userName)) {
            errors.userName = "Username must not contain spaces.";
        }

        if (!formData.firstName.trim()) {
            errors.firstName = "First name is required.";
        }
        if (!formData.lastName.trim()) {
            errors.lastName = "Last name is required.";
        }

        if (!validateEmail(formData.email)) {
            errors.email = "Please enter a valid email address.";
        }

        if (mode === 'create') {
            const passwordError = getPasswordError(formData.password);
            if (passwordError) {
                errors.password = passwordError;
            }
        }

        if (!formData.useCase) {
            errors.useCase = "Usecase is required.";
        }

        if (!formData.ClientID) {
            errors.ClientID = "Client is required.";
        }

        if (!formData.userRole) {
            errors.userRole = "UserRole is required.";
        }

        setFormErrors(errors);
    }, [formData, mode]);



    // Check if all fields are filled and valid
    const isFormValid = () => {
        const requiredFieldsFilled =
            formData.userName.trim() &&
            formData.firstName.trim() &&
            formData.lastName.trim() &&
            formData.ClientID &&
            formData.useCase &&
            validateEmail(formData.email) &&
            formData.userRole;

        const userNameIsValid = getUserNameError(formData.userName) === "";
        const passwordIsValid = mode === 'create' ? getPasswordError(formData.password) === "" : true;

        return requiredFieldsFilled && userNameIsValid && passwordIsValid;
    };


    const handleSubmit = async (event) => {
        event.preventDefault(); // optional here but good practice
        console.log('Submitted Form Data:', formData);
        if (mode === 'create') {
            let inputJSON = {
                // Command: configData.CREATE_USER,
                // SecurityToken: localStorage.getItem("SecurityToken"),
                UserName: formData.userName,
                FirstName: formData.firstName,
                LastName: formData.lastName,
                ...(formData.middleName && { MiddleName: formData.middleName }),   // Only if not empty
                EmailID: formData.email,
                Secret: formData.password,
                ClientId: formData.ClientID,
                UseCaseId: formData.useCase,
                IsActive: 1,
                UserType: "APP",
                ...(formData.isTwoFactorEnabled && {
                    IsTwoFactor: 1,
                    ...(formData.provider && { OTPProvider: formData.provider })
                }),
                UserRoleMasterId: formData.userRole
            };
            try {
                const parsedBody = await invokeLambda(configData.CREATE_USER, {
                    // ...lambdaConfig,
                    ...inputJSON,
                    SecurityToken: localStorage.getItem('SecurityToken'),
                    // "LoanGuid": localStorage.getItem('loanGuid'),
                });
                // if (Array.isArray(parsedBody.Output.impdata)) {
                if (parsedBody.Status) {
                    toast.success("User Created Sucessfully", {
                        position: "bottom-center",
                        autoClose: 2000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                    });
                    setFormData(initialFormData);             // <-- reset form data
                    setTouched({ email: false, password: false }); // <-- reset touched
                    setFormErrors({ email: '', password: '' });    // <-- reset errors
                    handleClose();
                    await getUserDetails();
                    await getUserListForUpdate();
                    // setTimeout(() => {
                    //    setDotLoader(true);
                    // }, 1000);
                } else {
                    toast.error("User Account Already Exists", {
                        position: "bottom-center",
                        autoClose: 2000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                    });
                    // setDotLoader(false);
                }
            } catch (err) {
                // Handle error if needed
                //  setDotLoader(false);

            }
            // Example: Call an API or further process the data
            // submitUser(formData);
        }
        else {
            let inputJson = {
                UserJSON: {
                    Edit: [
                        {
                            FirstName: formData.firstName,
                            LastName: formData.lastName,
                            MiddleName: formData.middleName,
                        },
                    ],
                    IsTwoFactorEnabled: formData.isTwoFactorEnabled == false ? 0 : 1,
                    OTPProvider: formData.provider == "" ? null : formData.provider,
                },
                UserSecurityId: userList.find(
                    (el) => el.UserName == userData.UserName
                ).SecurityId,
            };
            try {
                const parsedBody = await invokeLambda(configData.EDIT_USER_DETAILS, {
                    ...lambdaConfig,
                    ...inputJson,
                    SecurityToken: localStorage.getItem('SecurityToken'),
                    // "LoanGuid": localStorage.getItem('loanGuid'),
                });
                // if (Array.isArray(parsedBody.Output.impdata)) {
                if (parsedBody.Status) {
                    toast.success("User updated Sucessfully", {
                        position: "bottom-center",
                        autoClose: 2000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                    });
                    handleClose();
                    await getUserDetails();
                    await getUserListForUpdate();
                    if (typeof setSearchTerm === 'function') {
                        setSearchTerm('');
                    }
                    // setTimeout(() => {
                    //    setDotLoader(true);
                    // }, 1000);
                } else {
                    toast.error("User update Failed", {
                        position: "bottom-center",
                        autoClose: 2000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                    });
                    // setDotLoader(false);
                }
            } catch (err) {
                // Handle error if needed
                //  setDotLoader(false);

            }
            // Example: Call an API or further process the data
            // submitUser(formData);
        }

    };
    const clearform = () => {
        setFormData(initialFormData);  // Reset form inputs
        setTouched({                   // Reset touched state
            userName: false,
            firstName: false,
            lastName: false,
            email: false,
            password: false,
            useCase: false,
            ClientID: false,
            userRole: false,
        });
        setFormErrors({});             // Clear all form errors
        setClientList([]);             // Optional: reset clients
        setShowPassword(false);        // Optional: reset password visibility
        handleClose();                 // Close modal
    };

    return (
        <Modal show={show} onHide={clearform} backdrop="static" keyboard={false} dialogClassName="modal-90w">
            <Modal.Header closeButton>
                {mode === "edit" ? <Modal.Title>Edit User</Modal.Title> : <Modal.Title>User Creation</Modal.Title>}
            </Modal.Header>
            <Modal.Body className='admin-formfields'>
                <Form>
                    <Row>
                        <Col sm={3}>
                            <Form.Group className="mb-3">
                                <Form.Label>User Name<span className="required-asterisk">*</span></Form.Label>
                                <Form.Control
                                    size="sm"
                                    type="text"
                                    name="userName"
                                    value={formData.userName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    placeholder="Enter User Name"
                                    isInvalid={touched.userName && formErrors.userName}
                                    disabled={mode === "edit"}
                                />
                                {touched.userName && formErrors.userName && (
                                    <Form.Control.Feedback type="invalid">
                                        {formErrors.userName}
                                    </Form.Control.Feedback>
                                )}

                            </Form.Group>
                        </Col>
                        <Col sm={3}>
                            <Form.Group className="mb-3">
                                <Form.Label>First Name<span className="required-asterisk">*</span></Form.Label>
                                <Form.Control
                                    size="sm"
                                    type="text"
                                    name="firstName"
                                    value={formData.firstName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    placeholder="Enter first name"
                                    isInvalid={touched.firstName && formErrors.firstName}
                                />
                                {touched.firstName && formErrors.firstName && (
                                    <Form.Control.Feedback type="invalid">
                                        {formErrors.firstName}
                                    </Form.Control.Feedback>
                                )}

                            </Form.Group>
                        </Col>
                        <Col sm={3}>
                            <Form.Group className="mb-3">
                                <Form.Label>Last Name<span className="required-asterisk">*</span></Form.Label>
                                <Form.Control
                                    size="sm"
                                    type="text"
                                    name="lastName"
                                    value={formData.lastName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    placeholder="Enter last name"
                                    isInvalid={touched.lastName && formErrors.lastName}
                                />
                                {touched.lastName && formErrors.lastName && (
                                    <Form.Control.Feedback type="invalid">
                                        {formErrors.lastName}
                                    </Form.Control.Feedback>
                                )}

                            </Form.Group>
                        </Col>

                        <Col sm={3}>
                            <Form.Group className="mb-3">
                                <Form.Label>Middle Name</Form.Label>
                                <Form.Control size="sm" type="text"
                                    name="middleName"
                                    value={formData.middleName}
                                    onChange={handleChange}
                                    placeholder="Enter middle name" />
                            </Form.Group>
                        </Col>


                        <Col sm={3}>
                            <Form.Group className="mb-3">
                                <Form.Label>Email ID<span className="required-asterisk">*</span></Form.Label>
                                <Form.Control
                                    size="sm"
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    placeholder="Enter email id"
                                    isInvalid={touched.email && formErrors.email}
                                    disabled={mode === "edit"}
                                />
                                {touched.email && formErrors.email && (
                                    <Form.Control.Feedback type="invalid">
                                        {formErrors.email}
                                    </Form.Control.Feedback>
                                )}
                            </Form.Group>
                        </Col>
                        <Col sm={3}>
                            <Form.Group className="mb-3">
                                <Form.Label>Usecase<span className="required-asterisk">*</span></Form.Label>
                                <Form.Select
                                    size="sm"
                                    name="useCase"
                                    value={formData.useCase}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    isInvalid={touched.useCase && formErrors.useCase}
                                    disabled={mode === "edit"}
                                >
                                    <option value="" disabled>Select Usecase</option>
                                    {usecaseList.map((el) => (
                                        <option key={el.UseCaseID} value={el.UseCaseID}>{el.UseCaseName}</option>
                                    ))}
                                </Form.Select>
                                {touched.useCase && formErrors.useCase && (
                                    <Form.Control.Feedback type="invalid">
                                        {formErrors.useCase}
                                    </Form.Control.Feedback>
                                )}

                            </Form.Group>
                        </Col>
                        <Col sm={3}>
                            <Form.Group className="mb-3">
                                <Form.Label>Client<span className="required-asterisk">*</span></Form.Label>
                                <Form.Select
                                    size="sm"
                                    name="ClientID"
                                    value={formData.ClientID}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    isInvalid={touched.ClientID && formErrors.ClientID}
                                    disabled={mode === "edit"}
                                >
                                    <option value="" disabled>Select Client</option>
                                    {clientList.map((el) => (
                                        <option key={el.ClientID} value={el.ClientID}>{el.ClientName}</option>
                                    ))}
                                </Form.Select>
                                {touched.ClientID && formErrors.ClientID && (
                                    <Form.Control.Feedback type="invalid">
                                        {formErrors.ClientID}
                                    </Form.Control.Feedback>
                                )}

                            </Form.Group>
                        </Col>
                        {/* <Col sm={3}>
                            <Form.Group className="mb-3">
                                <Form.Select size="sm"
                                    name="additionalUseCase"
                                    value={formData.additionalUseCase}
                                    onChange={handleChange}>
                                    <option>Additional Use Case</option>
                                    <option value="1">One</option>
                                    <option value="2">Two</option>
                                    <option value="3">Three</option>
                                </Form.Select>
                            </Form.Group>
                        </Col> */}
                        {mode !== 'edit' && <Col sm={3}>
                            <Form.Group className="mb-3">
                                <Form.Label>Password<span className="required-asterisk">*</span></Form.Label>
                                <InputGroup size="sm">
                                    <Form.Control
                                        type={showPassword ? "text" : "password"}
                                        name="password"
                                        value={formData.password}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        placeholder="Password"
                                        isInvalid={touched.password && formErrors.password}
                                        disabled={mode === "edit"}
                                    />
                                    <InputGroup.Text onClick={togglePasswordVisibility} style={{ cursor: "pointer" }}>
                                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                                    </InputGroup.Text>
                                    {touched.password && formErrors.password && (
                                        <Form.Control.Feedback type="invalid">
                                            {formErrors.password}
                                        </Form.Control.Feedback>
                                    )}
                                </InputGroup>
                            </Form.Group>

                        </Col>}
                        <Col sm={3}>
                            <Form.Group className="mb-3">
                                <Form.Label>UserRole<span className="required-asterisk">*</span></Form.Label>
                                <Form.Select
                                    size="sm"
                                    name="userRole"
                                    value={formData.userRole}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    isInvalid={touched.userRole && formErrors.userRole}
                                    disabled={mode === "edit"}
                                >
                                    <option value="" disabled>Select UserRole</option>
                                    {userRole.map((el) => (
                                        <option key={el.RoleMasterId} value={el.RoleMasterId}>{el.RoleName}</option>
                                    ))}
                                </Form.Select>
                                {touched.userRole && formErrors.userRole && (
                                    <Form.Control.Feedback type="invalid">
                                        {formErrors.userRole}
                                    </Form.Control.Feedback>
                                )}

                            </Form.Group>
                        </Col>
                        <Col sm={3}>
                            <Form.Group className="mb-3">
                                <Form.Label>UserProvider</Form.Label>
                                <Form.Select size="sm"
                                    name="provider"
                                    value={formData.provider}
                                    onChange={handleChange}
                                    disabled={!formData.isTwoFactorEnabled}
                                >
                                    <option value="" disabled>Select UserProvider</option>
                                    {userProvider.map((el) => (
                                        <option value={el.Prvdrs}>{el.Prvdrs}</option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col sm={3} className='d-flex align-items-center'>
                            <Form.Group className="mb-3">
                                <Form.Check
                                    type="checkbox"
                                    id="custom-checkbox"
                                    label="IsTwoFactorEnabled"
                                    name="isTwoFactorEnabled"
                                    checked={formData.isTwoFactorEnabled}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" size='sm' onClick={clearform}>
                    Close
                </Button>
                {mode === "edit" ? <Button variant="primary" type='submit' size='sm' onClick={handleSubmit}>
                    Update
                </Button> : <Button variant="primary" type='submit' size='sm' onClick={handleSubmit} disabled={!isFormValid()}>
                    Add
                </Button>}
            </Modal.Footer>
        </Modal>
    );
};
export default UserCreation;